/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type EmailUserDetailsChangeRequestMutationInput = {
    email: string;
    accountNumber: string;
    currentRegion: string;
    newRegion: string;
    currentCell: string;
    newCell: string;
    clientMutationId?: string | null;
};
export type ChangeDetailsMutationVariables = {
    input: EmailUserDetailsChangeRequestMutationInput;
};
export type ChangeDetailsMutationResponse = {
    readonly emailUserDetailsChange: {
        readonly clientMutationId: string | null;
        readonly accepted: ReadonlyArray<string> | null;
        readonly rejected: ReadonlyArray<string> | null;
    } | null;
};
export type ChangeDetailsMutation = {
    readonly response: ChangeDetailsMutationResponse;
    readonly variables: ChangeDetailsMutationVariables;
};



/*
mutation ChangeDetailsMutation(
  $input: EmailUserDetailsChangeRequestMutationInput!
) {
  emailUserDetailsChange(input: $input) {
    clientMutationId
    accepted
    rejected
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailUserDetailsChangeRequestMutationPayload",
    "kind": "LinkedField",
    "name": "emailUserDetailsChange",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accepted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rejected",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangeDetailsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChangeDetailsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3c5c2d24c83a866442b01d80f6e9597e",
    "id": null,
    "metadata": {},
    "name": "ChangeDetailsMutation",
    "operationKind": "mutation",
    "text": "mutation ChangeDetailsMutation(\n  $input: EmailUserDetailsChangeRequestMutationInput!\n) {\n  emailUserDetailsChange(input: $input) {\n    clientMutationId\n    accepted\n    rejected\n  }\n}\n"
  }
};
})();
(node as any).hash = '7461b0d9d0b65d35df5a942449df5719';
export default node;
